import React, { useRef } from 'react';

interface HeatmapOverlayProps {
  visible: boolean;
  fileId?: number;
  /** Left offset in pixels (to align with the seek bar). */
  left?: number;
  /** Width in pixels (to match the seek bar width). */
  width?: number;
}

export const HeatmapOverlay = React.memo(function HeatmapOverlay({ visible, fileId, left, width }: HeatmapOverlayProps) {
  // No fileId → nothing to fetch, don't render at all
  if (fileId == null) return null;

  // Keep the last URL in a ref so the image stays visible during the
  // CSS collapse transition.  Only update when toggled ON (fresh
  // cache-bust timestamp).
  const lastUrlRef = useRef('');
  if (visible) {
    lastUrlRef.current = `url('heatmap?ts=${Date.now()}&file=${fileId}&user=-1')`;
  }

  const style: React.CSSProperties = lastUrlRef.current
    ? { backgroundImage: lastUrlRef.current }
    : {};

  // Apply seek bar alignment when dimensions are provided
  if (left != null) style.left = left;
  if (width != null) style.width = width;

  const className = `kollab-player-heatmap-overlay${visible ? ' kollab-player-heatmap-overlay--visible' : ''}`;

  return (
    <div
      className={className}
      style={style}
      aria-hidden="true"
    />
  );
});
